<template>
    <div class="p-3 md:p-10 bg-white">
        <a
            v-for="(job, index) in jobs"
            :key="job.id + '-' + index"
            :href="'/jobs/' + job.id"
            class="rounded-none text-black no-underline hover:no-underline"
        >

            <div
                :class="{
                    'border-b-[1px] border-solid border-[#dddddd] mb-10': index !== jobs.length - 1
                }"
            >
                <div class="flex gap-5 md:gap-10">
                    <div class="bg-gray-100 w-32 h-32 md:w-[175px] md:h-[175px] bg-cover bg-center" :style="'background-image: url(' + job.jobable.image_url + ')'"></div>
                    <div class="flex-grow flex-1">
                        <div class="flex flex-wrap items-center">
                            <div>
                                <img
                                    :src="job.jobable.brand.avatar_url"
                                    :alt="job.jobable.brand.name"
                                    class="mr-5"
                                    style="height: 50px; width: 50px; border-radius: 100%;"
                                />
                            </div>
                            <p class="flex-grow font-bold uppercase">{{ job.jobable.brand.name }}</p>
                            <p class="mt-4 leading-7 font-semibold text-white text-xs uppercase bg-[var(--magic-color)] px-4">Gå til job</p>
                        </div>
                        <div class="md-content-job">
                            <p class="my-5 font-bold uppercase">{{ job.jobable.excerpt }}</p>

                            <div class="flex mt-5 justify-between items-center">
                                <span class="block" :class="job.jobable.platform ? job.jobable.platform.icon : ''" style="    font-size: 30px;color: var(--magic-color);"></span>
                                <amount style="font-weight: 600;color: var(--magic-color);" class="flex-grow text-right" :value="job.influencer_profit">
                                    &nbsp;
                                </amount>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="content-jobs block md:hidden">
                    <p class="my-5 font-bold uppercase">{{ job.jobable.excerpt }}</p>
                    <div class="flex mt-5 gap-3 items-center">
                        <span class="block" :class="job.jobable.platform ? job.jobable.platform.icon : ''" style="    font-size: 30px;color: var(--magic-color);"></span>
                        <amount style="font-weight: 600;color: var(--magic-color);" class="flex-grow text-left md:text-right" :value="job.influencer_profit">
                            &nbsp;
                        </amount>
                    </div>
                </div>

                <div class="ranger-slider-on-white-bg" style="    margin: 0 -18px 0 -12px;">
                    <job-status-progress-bar :chat-thread-id="1" :data-job="job" :steps="brandJobSteps" class="mb-5" :show-only-steps="true"></job-status-progress-bar>
                </div>
            </div>

            <!--
            <div class="flex items-center mb-3">
                <div>
                    <job-status :status="job.status"></job-status>
                </div>

                <div class="flex-1 mr-2 text-right" v-text="job.jobable.brand.name" />

                <img
                    :src="job.jobable.brand.avatar_url"
                    :alt="job.jobable.brand.name"
                    class="spark-profile-photo"
                />
            </div>

            <div class="flex items-center">
                <div class="flex-1">
                    <h3 class="mb-2" v-text="job.jobable.name" />

                    <TextBlock class="mb-5" :value="job.jobable.excerpt" />

                    <div class="lead m-0 font-bold">
                        <amount :value="job.influencer_profit">
                            &nbsp;
                        </amount>
                    </div>
                </div>

                <div class="p-3 mb-6">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>
            -->
        </a>
    </div>
</template>

<style lang="less" type="text/less">
.md-content-job {
    display: none;
}
@media (min-width: 768px) {
    .md-content-job {
        display: block;
    }
}
</style>

<script type="text/babel">
import CampaignCard from 'dashboard-js/components/campaigns/CampaignCard'
import TextBlock from 'dashboard-js/components/utilities/TextBlock'
import { brandJobSteps } from 'dashboard-js/pages/brand/BrandJobShowPage'
export default {
    components: { TextBlock, CampaignCard },

    directives: {},

    mixins: [],

    props: ['jobs'],

    data() {
        return {
            brandJobSteps,
        }
    },

    computed: {},

    created() {},

    methods: {},
}
</script>
